<template>
<nav class="vpn-nav" aria-label="Primary">
  <div class="vpn-nav__inner">
    <a class="vpn-nav__brand" href="/" title="Secure VPN" @click.prevent="goHome">
      <img class="vpn-nav__logo" src="@/assets/vpn/logo.webp" alt="Secure VPN" width="40" height="40">
      <span class="vpn-nav__name">Secure VPN</span>
    </a>

    <div class="vpn-nav__actions">
      <a
        class="vpn-nav__link"
        href="/"
        :class="{ 'is-active': isHomePage }"
        @click.prevent="goHome"
      >{{ nav.home }}</a>
      <a
        class="vpn-nav__link"
        href="/free-proxy-list/"
        :class="{ 'is-active': isProxyPage }"
        @click.prevent="goProxyList"
      >{{ nav.proxies }}</a>
      <a
        class="vpn-nav__link"
        href="/blog/"
        :class="{ 'is-active': isBlogPage }"
        @click.prevent="goBlog"
      >{{ nav.blog }}</a>
      <details ref="platformMenu" class="vpn-nav__dropdown">
        <summary
          class="vpn-nav__link vpn-nav__dropdown-toggle"
          :class="{ 'is-active': isPlatformPage }"
        >
          {{ nav.device }}
          <svg class="vpn-nav__chevron" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </summary>
        <div class="vpn-nav__menu">
          <router-link
            v-for="item in platformLinks"
            :key="item.to"
            class="vpn-nav__menu-link"
            :class="{ 'is-active': isActivePath(item.to) }"
            :to="item.to"
            @click.native="closePlatformMenu"
          >
            {{ item.label }}
          </router-link>
        </div>
      </details>
      <a class="vpn-nav__cta" href="/download/">
        <span class="vpn-nav__cta-full">{{ nav.getVpn }}</span>
        <span class="vpn-nav__cta-short">{{ nav.getVpnShort }}</span>
      </a>
      <details ref="langMenu" class="vpn-nav__dropdown vpn-nav__lang">
        <summary
          class="vpn-nav__link vpn-nav__dropdown-toggle vpn-nav__lang-toggle"
          aria-label="Choose language"
        >
          <svg class="vpn-nav__lang-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
            <circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.6" />
            <path
              d="M4 12h16M12 4c2.2 2.5 3.3 5.2 3.3 8s-1.1 5.5-3.3 8c-2.2-2.5-3.3-5.2-3.3-8S9.8 6.5 12 4z"
              stroke="currentColor"
              stroke-width="1.4"
            />
          </svg>
          <span>{{ currentLanguageShort }}</span>
          <svg class="vpn-nav__chevron" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </summary>
        <div class="vpn-nav__menu vpn-nav__menu--lang" role="listbox">
          <button
            v-for="lang in languageOptions"
            :key="lang.code"
            type="button"
            class="vpn-nav__menu-link vpn-nav__lang-option"
            :class="{ 'is-active': lang.code === activeLanguageCode }"
            :aria-current="lang.code === activeLanguageCode ? 'true' : null"
            @click="onPickLanguage(lang)"
          >
            <span>{{ lang.label }}</span>
            <span v-if="lang.code === activeLanguageCode" class="vpn-nav__lang-check" aria-hidden="true">✓</span>
          </button>
        </div>
      </details>
    </div>
  </div>
</nav>
</template>

<script>
import { getLanguageOptions, getNavigationCopy } from '@/data/vpnNavigation';

export default {
  name: 'HeadNav',
  data() {
    return {
      platformLinks: [
        { label: 'Windows', to: '/for-windows/' },
        { label: 'macOS', to: '/for-mac/' },
        { label: 'iPhone & iPad', to: '/for-iphone/' },
        { label: 'Linux', to: '/for-linux/' },
        { label: 'Chrome', to: '/for-chrome/' },
        { label: 'Firefox', to: '/for-firefox/' },
      ],
      languageOptions: getLanguageOptions(),
    }
  },
  props: {
    selectedLanguage: {
      type: String,
      default: 'en',
    },
    page: {
      type: String,
      default: 'home',
    },
    gotodownload: {
      type: Function,
      default: null,
    },
    apk: {
      type: Object,
      default: null,
    },
  },
  computed: {
    nav() {
      return getNavigationCopy(this.selectedLanguage);
    },
    isHomePage() {
      const path = (this.$route && this.$route.path) || ''
      return path === '/' || this.page === 'home' || this.page === 'en-gb'
    },
    isProxyPage() {
      const path = (this.$route && this.$route.path) || ''
      return path === '/free-proxy-list' || path === '/free-proxy-list/' || this.page === 'free-proxy-list'
    },
    isBlogPage() {
      const path = (this.$route && this.$route.path) || ''
      return (
        path === '/blog' ||
        path === '/blog/' ||
        path === '/is-nordvpn-free-how-to-get-free-trial/' ||
        path === '/10-best-yesmovies-alternative-legal/' ||
        path === '/10-platforms-to-watch-boxing-live-stream/' ||
        path === '/10-best-fmovies-alternatives-free-legal-sites/' ||
        path === '/10-best-fmovies-alternatives-free-legal-sites' ||
        path === '/nordvpn-vs-expressvpn-for-streaming-which-is-better/' ||
        path === '/nordvpn-vs-expressvpn-for-streaming-which-is-better' ||
        this.page === 'blog'
      )
    },
    isPlatformPage() {
      return this.platformLinks.some((item) => this.isActivePath(item.to))
    },
    activeLanguageCode() {
      const key = this.$route && this.$route.meta && this.$route.meta.localeKey
      if (key) {
        return key
      }
      return this.selectedLanguage === 'en' || !this.selectedLanguage ? 'en' : this.selectedLanguage
    },
    currentLanguageShort() {
      const current = this.languageOptions.find((item) => item.code === this.activeLanguageCode)
      return (current && current.short) || 'EN'
    },
  },
  methods: {
    isActivePath(path) {
      const currentPath = (this.$route && this.$route.path) || ''
      return currentPath === path || currentPath === path.replace(/\/$/, '')
    },
    closePlatformMenu() {
      if (this.$refs.platformMenu) {
        this.$refs.platformMenu.open = false
      }
    },
    closeLangMenu() {
      if (this.$refs.langMenu) {
        this.$refs.langMenu.open = false
      }
    },
    onPickLanguage(lang) {
      if (!lang || !lang.path) {
        this.closeLangMenu()
        return
      }
      if (lang.code === this.activeLanguageCode) {
        this.closeLangMenu()
        return
      }
      this.closeLangMenu()
      this.closePlatformMenu()
      this.$router.push(lang.path).catch(() => {
        window.location.assign(lang.path)
      })
    },
    goHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    },
    goProxyList() {
      if (this.$route.path !== '/free-proxy-list' && this.$route.path !== '/free-proxy-list/') {
        this.$router.push('/free-proxy-list/').catch(() => {
          window.location.assign('/free-proxy-list/')
        })
      }
    },
    goBlog() {
      if (this.$route.path !== '/blog' && this.$route.path !== '/blog/') {
        this.$router.push('/blog/').catch(() => {
          window.location.assign('/blog/')
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.vpn-nav {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid #e8e4f8;
  max-width: 100%;
  overflow: visible;
}

.vpn-nav__inner {
  width: var(--vpn-content-width);
  max-width: 100%;
  margin: 0 auto;
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  box-sizing: border-box;
  padding: 0 4px;
}

.vpn-nav__brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #1f2430;
  flex: 0 1 auto;
  min-width: 0;
}

.vpn-nav__logo {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  object-fit: cover;
  flex-shrink: 0;
}

.vpn-nav__name {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.02em;
  white-space: nowrap;
}

.vpn-nav__actions {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 0 1 auto;
  min-width: 0;
}

.vpn-nav__link {
  display: inline-block;
  color: #5b6475;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.2s ease;

  &:hover,
  &.is-active {
    color: #6d4aff;
  }
}

.vpn-nav__dropdown {
  position: relative;
  flex: 0 0 auto;
}

.vpn-nav__dropdown-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  list-style: none;
}

.vpn-nav__dropdown-toggle::-webkit-details-marker {
  display: none;
}

.vpn-nav__chevron {
  width: 14px;
  height: 14px;
  transition: transform 0.2s ease;
}

.vpn-nav__dropdown[open] .vpn-nav__chevron {
  transform: rotate(180deg);
}

.vpn-nav__menu {
  position: absolute;
  top: calc(100% + 14px);
  right: 0;
  z-index: 110;
  display: grid;
  min-width: 184px;
  padding: 8px;
  border: 1px solid #e8e4f8;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 16px 40px rgba(31, 36, 48, 0.14);
}

.vpn-nav__lang {
  flex-shrink: 0;
}

.vpn-nav__lang-toggle {
  gap: 6px;
}

.vpn-nav__lang-icon {
  flex: none;
  color: #6d4aff;
}

.vpn-nav__menu--lang {
  right: 0;
  left: auto;
  min-width: 196px;
  max-height: min(70vh, 420px);
  overflow-y: auto;
  grid-template-columns: 1fr;
}

.vpn-nav__lang-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: 0;
  background: none;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.vpn-nav__lang-option.is-active {
  color: #6d4aff;
  font-weight: 700;
}

.vpn-nav__lang-check {
  flex: none;
  margin-left: 12px;
  color: #6d4aff;
  font-size: 13px;
}

.vpn-nav__menu-link {
  display: block;
  padding: 9px 12px;
  border-radius: 8px;
  color: #5b6475;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.vpn-nav__menu-link:hover,
.vpn-nav__menu-link.is-active {
  background: #f4f0ff;
  color: #6d4aff;
}

.vpn-nav__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 10px 18px;
  border-radius: 999px;
  background-color: #6d4aff;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  box-shadow: 0 10px 24px rgba(109, 74, 255, 0.35);
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.vpn-nav__cta:hover {
  background-color: #5b3fe8;
  color: #ffffff;
  transform: translateY(-1px);
}

.vpn-nav__cta-short {
  display: none;
}

@media (max-width: 768px) {
  .vpn-nav__inner {
    width: 100%;
    max-width: 100%;
    min-height: 56px;
    gap: 8px;
    padding: 0 12px;
  }

  .vpn-nav__logo {
    width: 32px;
    height: 32px;
  }

  .vpn-nav__name {
    font-size: 15px;
  }

  .vpn-nav__actions {
    gap: 7px;
  }

  .vpn-nav__link {
    font-size: 12px;
  }

  .vpn-nav__menu {
    position: fixed;
    top: 62px;
    right: 12px;
    left: 12px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    min-width: 0;
  }

  .vpn-nav__menu--lang {
    grid-template-columns: 1fr;
    right: 12px;
    left: auto;
    width: min(280px, calc(100vw - 24px));
  }

  .vpn-nav__cta {
    padding: 8px 12px;
    font-size: 12px;
  }

  .vpn-nav__cta-full {
    display: none;
  }

  .vpn-nav__cta-short {
    display: inline;
  }
}

@media (max-width: 480px) {
  .vpn-nav__inner {
    padding: 0 10px;
  }

  // 极窄屏：只保留 logo + 关键，避免导航被裁切
  .vpn-nav__name {
    display: none;
  }

  .vpn-nav__link {
    display: none;
  }

  .vpn-nav__dropdown-toggle {
    display: inline-flex;
  }

  .vpn-nav__actions {
    gap: 0;
  }

  .vpn-nav__cta {
    padding: 8px 12px;
    font-size: 12px;
  }
}
</style>
